import { render, staticRenderFns } from "./PrimaryIcon.vue?vue&type=template&id=4c7b8e70&"
import script from "./PrimaryIcon.vue?vue&type=script&lang=js&"
export * from "./PrimaryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports